import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'ark-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() label: string;
  @Input() type: string;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<any>();

  constructor() {
  }

  onClickButton(event) {
    this.onClick.emit(event);
  }

  ngOnInit() {
  }

}
